import { createClientPromiseManager, createServerPromiseManager } from './promises'

export const promiseManager =
  typeof window === 'undefined' || process.env.NODE_ENV === 'test'
    ? createServerPromiseManager()
    : createClientPromiseManager()
